export const messages = {
  title: '出行',
  saving: '保存中…',
  loading: '加载中…',
  empty: '暂无场景数据',
  clear: '清空勾选',
  cleared: '已清空勾选',
  clearFailed: '清空失败，请重试',
  loadFailed: '加载失败'
} as const
